<template>
    <div>
        <div v-if="(SubHeader !== 'BookServiceHeader') || (SubHeader === 'BookServiceHeader')" 
        class="residentportal-header-login" ref="residentportal-header-login"
        v-bind:style="'background:' + computedBackgroundRGB" >
            <main-header></main-header>
        </div>
        <div v-else>
            <main-header></main-header>
        </div>
        <div class="residentportal-default residentportal-sitemap">
            <div class="container">
                <h1 class="residentportal-sitemap__title">Sitemap</h1>
                <ul>
                    <li><router-link to="/login">Login</router-link></li>
                    <li><router-link to="/register">Registration</router-link></li>
                    <li><router-link to="/forgotpassword">Forgot Password</router-link></li>
                </ul>
            </div>
        </div>
        <main-footer></main-footer>
    </div>
</template>

<script>
    import MainHeader from '../common/components/Header';
    import MainFooter from '../common/components/Footer';

    const routeSubHeader = {
        '/booking/home': 'BookServiceHeader',
        '/booking/my-profile': 'MyProfile',
        '/booking/faq': 'FreqAsk'
        
    };
    export default {
        components: {
            MainHeader,
            MainFooter,
        },
        computed: {
            personalInfo(){
                return this.$store.getters.GET_PERSONAL_INFO;
            },
            SubHeader() {
                return routeSubHeader[this.$route.fullPath];
            },
            MainUISettings() {
                return this.$store.getters['GET_MAIN_UI']; 
            },
            computedBackgroundRGB() { 
                var background = "linear-gradient(45deg, " + this.convertHex(this.$store.getters.GET_MAIN_UI.banner_gradient_dark)+ " 25%, " + this.convertHex (this.$store.getters.GET_MAIN_UI.banner_gradient_light) + " 79%), url("+ process.env.MIX_APP_URL + this.$store.getters.GET_MAIN_UI.banner_image +" );";
                return background;
            },
            backgroundRGB() {
                var background = "linear-gradient(45deg, " + this.convertHex(this.$store.getters.GET_MAIN_UI.banner_gradient_dark)+ " 25%, " + this.convertHex (this.$store.getters.GET_MAIN_UI.banner_gradient_light) + " 79%);";
                return background;
            },
        },
        methods:{
            convertHex(color) {
                color = color.replace('#', '')
                let r = parseInt(color.substring(0, 2), 16)
                let g = parseInt(color.substring(2, 4), 16)
                let b = parseInt(color.substring(4, 6), 16)
                let result = 'rgba(' + r + ',' + g + ',' + b + ',' + 0.75 + ')'
                return result
            },
        }
    }
</script>
